export const baseDevConfig = {
  WEB_API_NAME: "archform-dashboard-back-dev",
  BACK_API_NAME: "archform-dashboard-back-dev",
  BACK_API_NAME_V2: "archform-backend",
  BACK_API_V2_ACCESS_POLICY_API: "archform-backend-access-policy-api",
  S3_BUCKET_ARCHFORM_TEMP_FILE: "archform-temp-file-dev",
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V2: "archform-patient-data-v2", 
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V1: "archform-patient-data-v1-dev",
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V1_RESIZED: "archform-patient-data-v1-resized-dev",
  S3_BUCKET_ARCHFORM_PATIENTS_V1: "archform-patients-v1-dev",
  S3_BUCKET_ARCHFORM_PATIENTS_V2: "archform-patients-v2-dev",
  S3_BUCKET_ARCHFORM_WEBVIEWER_DATA_V2: "archform-webviewer-data-v2-dev",
  S3_BUCKET_ARCHFORM_AUTO_RETAINER_DATA: "archform-autoretainer-data-test",
  AWS_REGION: "ap-northeast-1",
  AMPLIFY_USER_POOL_ID: "ap-northeast-1_CmzWNY3qk",
  AMPLIFY_IDENTITY_POOL_ID: "ap-northeast-1:e5103d9f-34af-4131-be8b-fd5c9d3cec87",
  AMPLIFY_USER_POOL_WEB_CLIENT_ID: "61fbek093fje0sq5lb51t77ajm",
  WEB_API_ENDPOINT: "https://spy237161e.execute-api.ap-northeast-1.amazonaws.com/Prod/",
  BACK_API_ENDPOINT: "https://spy237161e.execute-api.ap-northeast-1.amazonaws.com/Prod",
  BACK_API_ENDPOINT_V2: "https://2tj1us1ebl.execute-api.ap-northeast-1.amazonaws.com/Prod",
  SNS_TOPIC_ARN: "arn:aws:sns:ap-northeast-1:552997682487:ArchFormDynamoDBOrderCommentUpdate",
  WEB_VIEWER_BASE_URL: "https://d19d4bkpjlpp6m.cloudfront.net",
  WEB_EDITOR_BASE_URL: "https://d2d3jan3h1u14n.cloudfront.net",
  ARCHFORM_DASH_V1_BASE_URL: "https://d1q6adjuiwpqnz.cloudfront.net",
  SETUP_ORDER_TOPIC_ARN: "arn:aws:sns:ap-northeast-1:552997682487:ArchFormDynamoDBSetupOrderUpdate-dev",
  MFG_ORDER_TOPIC_ARN: "arn:aws:sns:ap-northeast-1:552997682487:ArchFormDynamoDBMFGOrderUpdate-dev",
  BILLING_EMAIL_TOPIC_ARN: "arn:aws:sns:ap-northeast-1:552997682487:ArchFormBillingEmailUpdate-dev",
  PATIENT_MIGRATION_TOPIC_ARN: "arn:aws:sns:ap-northeast-1:552997682487:ArchFormPatientMigration-dev",
  SLACK_CHANNEL_LINK_ORIGIN: "https://d2spg4xirn83ur.cloudfront.net",
  GOOGLE_MAPS_API_KEY: "AIzaSyBNatfeTU-151byapaVFBNgXTR2TYfrzuc",
}

export const baseProdConfig = {
  WEB_API_NAME: "archform-dashboard-migrate",
  BACK_API_NAME: "archform-dashboard-back",
  BACK_API_NAME_V2: "archform-backend",
  BACK_API_V2_ACCESS_POLICY_API: "archform-backend-access-policy-api",
  S3_BUCKET_ARCHFORM_TEMP_FILE: "archform-temp-file",
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V1: "archform-patient-data-v1",
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V1_RESIZED: "archform-patient-data-v1-resized",
  S3_BUCKET_ARCHFORM_PATIENTS_V1: "archform-patients-v1",
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V2: "archform-patient-data-v2",
  S3_BUCKET_ARCHFORM_PATIENTS_V2: "archform-patients-v2",
  S3_BUCKET_ARCHFORM_WEBVIEWER_DATA_V2: "archform-webviewer-data-v2",
  S3_BUCKET_ARCHFORM_AUTO_RETAINER_DATA: "archform-autoretainer-data-test",
  AWS_REGION: "us-east-2",
  AMPLIFY_USER_POOL_ID: "us-east-2_bNM3Ho5WZ",
  AMPLIFY_IDENTITY_POOL_ID: "us-east-2:4174969e-0d9e-4380-8d38-99e4f1f97cf7",
  AMPLIFY_USER_POOL_WEB_CLIENT_ID: "663500b1d36judotkr083nilhn",
  WEB_API_ENDPOINT: "https://kirnmhx6z8.execute-api.us-east-2.amazonaws.com/prod/",
  BACK_API_ENDPOINT: "https://tagxkis576.execute-api.us-east-2.amazonaws.com/prod",
  BACK_API_ENDPOINT_V2: "https://d61bk6a7pl.execute-api.us-east-2.amazonaws.com/Prod",
  SNS_TOPIC_ARN: "arn:aws:sns:us-east-2:680135637357:ArchFormDynamoDBOrderCommentUpdate",
  WEB_VIEWER_BASE_URL: "https://webviewer2.archform.com",
  WEB_EDITOR_BASE_URL: "https://webeditor.archform.com",
  ARCHFORM_DASH_V1_BASE_URL: "https://dashboard1.archform.com",
  SETUP_ORDER_TOPIC_ARN: "arn:aws:sns:us-east-2:680135637357:ArchFormDynamoDBSetupOrderUpdate",
  MFG_ORDER_TOPIC_ARN: "arn:aws:sns:us-east-2:680135637357:ArchFormDynamoDBMFGOrderUpdate",
  BILLING_EMAIL_TOPIC_ARN: "arn:aws:sns:us-east-2:680135637357:ArchFormBillingEmailUpdate",
  PATIENT_MIGRATION_TOPIC_ARN: "arn:aws:sns:us-east-2:680135637357:ArchFormPatientMigration",
  SLACK_CHANNEL_LINK_ORIGIN: "https://dashboard2.archform.com",
  GOOGLE_MAPS_API_KEY: "AIzaSyCffhjXMfesXiUhlL7pb9IvcQ12lmJKADY",
}